import { Button, Container, Grid, InputAdornment, Modal } from "@material-ui/core";
import { TextField } from "@mui/material";
import React, {useCallback, useMemo} from "react";
import { useTablePayment } from "../../context/tablePayment/TablePaymentContext";
import { PaymentType } from "../../models/payment/IPay";
import { TablePaymentHeader } from "./header/TablePaymentHeader";
import PaymentCardModal from "./paymentSelect/paymentCardModal/PaymentCardModal";
import { TablePaymentSelect } from "./paymentSelect/TablePaymentSelect";
import { TableResumeView } from "./resume/TableResumeView";
import styles from './TablePaymentPage.module.scss';
import {Skeleton} from "../../components/skeleton/Skeleton";
import {StripePayment} from "../../components/stripePayment/StripePayment";
import {useUi} from "../../context/ui/UIContext";
import { moneyMaskNumber } from "utils/mask/money";

export const TablePaymentPage = () => {
    const {
        loadingExtracts,
        totalAmount,
        totalAmountToPay,
        paymentType,
        handleConfirmPayment,
        selectCardOpen,
        setSelectCardOpen,
        hasSelectedCard,
        card,
        setPaymentType,
        extractsToPay,
        sharedExtracts,
        paymentValue,
        exhibitionPaymentValue,
        changeManualPaymentValue,
        updatePaymentMethod,
        pedidoId,
        companyId,
    } = useTablePayment();
    const { toastFullScreen } = useUi();

    const isAvailablePayment = useMemo((): boolean => {
        let lTotal = sharedExtracts?.command.remainingBalance ?? 0;
        let lTotalFee = sharedExtracts?.command.totalFee ?? 0;
        return totalAmountToPay <= (lTotal + lTotalFee);
    }, [sharedExtracts, totalAmountToPay]);

    const onClickPayment = useCallback(async () => {
        handleConfirmPayment();
    }, [handleConfirmPayment])

    const manualPaymentChange = useCallback(async (e: any) => {
        const raw = e.target.value.replace(/\D/g, "");
        const valueInCents = parseInt(raw || "0", 10);
        changeManualPaymentValue(valueInCents / 100);
        updatePaymentMethod(PaymentType.NAO_INFORMADO);
    }, [changeManualPaymentValue]);

    const getAdditionalMetadata = useMemo((): Record<string, any> => {
        return {
            pedidoId: pedidoId,
            companyId: companyId,
        }
    }, [companyId, pedidoId]);

    return (<>
        <div className={styles.tablePaymentPageWrapper}>
            <TablePaymentHeader/>
            <Container className={styles.tablePaymentContainer}>
                {loadingExtracts &&
                    <Skeleton items={4} cardStyle={styles.skeletonCard} itemStyle={styles.skeletonItem}/>}
                {!loadingExtracts && <div>
                    {!!extractsToPay ?
                        <Grid
                            container
                            style={{textAlign: "center", margin: "auto"}}
                        >
                            <Grid item xs={12}>
                                <TableResumeView/>
                            </Grid>
                        </Grid>
                     : <h2 className={styles.noExtractTitle}>Informe o valor que deseja pagar</h2>}
                    <Grid item xs={12} className={styles.totalAmount}>
                        <TextField
                            required
                            autoComplete="off"
                            error={Number(paymentValue) > (sharedExtracts?.command.remainingBalance ?? 0)}
                            variant="standard"
                            value={exhibitionPaymentValue}
                            onChange={(e) => manualPaymentChange(e)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        R$
                                    </InputAdornment>
                                ),
                                classes: {
                                    input: styles.totalAmountInput,
                                },
                                disableUnderline: true,
                            }}
                            style={{maxWidth: "100%"}}
                            size="medium"
                        />
                        {!isAvailablePayment
                            && <h3 className={styles.textColorAlert}>O valor informado é superior ao valor pendente da comanda</h3>}
                        <hr/>
                        <h3>Total: {moneyMaskNumber(totalAmount)}</h3>
                    </Grid>
                </div>}
                <Grid item xs={12} className={styles.paymentSelectContainer}>
                    <TablePaymentSelect/>
                </Grid>
            </Container>
            <Container className={styles.paymentButton}>
                {paymentType === PaymentType.STRIPE ? <StripePayment
                    amount={totalAmountToPay}
                    additionalMetadata={getAdditionalMetadata}
                    onError={(error) => {
                        console.log(error);
                        toastFullScreen(
                            error,
                            "error",
                            "error",
                            3000,
                        );
                    }}/> 
                    :
                    <Button
                    onClick={() => onClickPayment()}
                color="primary"
                size="large"
                variant="contained"
                fullWidth
                disableElevation
                disabled={paymentType === PaymentType.NAO_INFORMADO || !totalAmountToPay || !hasSelectedCard || !isAvailablePayment}>
                Pagar
            </Button>}
            </Container>
        </div>

        <Grid container>
            <Modal
                open={selectCardOpen}
                onClose={() => {
                    if (!card) {
                        setPaymentType(PaymentType.NAO_INFORMADO);
                    }
                    setSelectCardOpen(false)
                }}
                className={styles.modalContainer}
            >
                <PaymentCardModal/>
            </Modal>
        </Grid>
    </>);
};
